import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import NavbarPortal from './NavbarPortal';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

const navbarRoot = ReactDOM.createRoot(document.getElementById('navbar-root'));
navbarRoot.render(<NavbarPortal />);
